/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
};
export const attendanceEmployeeModalReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case actionType.EMPLOYEE_ATTENDANCE_MODAL + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.EMPLOYEE_ATTENDANCE_MODAL + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.EMPLOYEE_ATTENDANCE_MODAL + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.EMPLOYEE_ATTENDANCE_MODAL + '_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true,
        msgError: action.err,
        status: action.status
      }
    default:
      return state;
  }
};
